import { useQuery } from "@tanstack/react-query";
import api from "../../../api/api";
import { QUERY_ACCOUNT_STATEMENTS } from "../../../api/queryKeys";

/*
  This gets the statement detail html version.
*/

export const getStatementDetail = (
  accountNum: string | undefined,
  yearMonth: string | undefined
) =>
  api
    .get<string>(
      `v01/me/accounts/${accountNum}/statements/${yearMonth}?format=html`
    )
    .then((res) => res.data);

export default function useGetAccountStatementDetail(
  accountNum: string | undefined,
  yearMonth: string | undefined
) {
  return useQuery(
    [QUERY_ACCOUNT_STATEMENTS, accountNum, yearMonth],
    () => getStatementDetail(accountNum, yearMonth),
    { enabled: !!accountNum && !!yearMonth } // only fetch if accountNum is truthy
  );
}
